import { all_routes } from "../../../../feature-module/router/all_routes";

export const studentSidebarData = [
  {
    title: "home",
    icon: "fa-solid fa-table-columns",
    route: all_routes.studentDashboard,
  },
  {
    title: "enrolledCourses",
    icon: "fa-solid fa-graduation-cap",
    route: all_routes.studentCourses,
  },
  {
    title: "liveClasses",
    icon: "fa-solid fa-video",
    route: all_routes.studentLiveClasses,
  },
  {
    title: "calendar",
    icon: "fa-solid fa-calendar",
    route: all_routes.studentEvents,
  },
  {
    title: "progress",
    icon: "fa-solid fa-bars-progress",
    route: all_routes.studentProgress,
  },
  {
    title: "quiz, assign and exam",
    icon: "fa-solid fa-clipboard-question",
    route: all_routes.studentQuiz,
    subRoute: all_routes.studentQuizQuestion,
  },

  {
    title: "grades",
    icon: "fa-solid fa-medal",
    route: all_routes.studentGrades,
  },
  {
    title: "forum",
    icon: "fa-solid fa-comments",
    route: all_routes.studentForum,
  },
  
  {
    title: "profile",
    icon: "fa-solid fa-user",
    route: all_routes.studentProfile,
  },
  // {
  //   title: "certificates",
  //   icon: "isax isax-note-215",
  //   route: all_routes.studentCertificates,
  // },

  // Đây là wishlist
  // Đã xóa vì không cần thiết
  // {
  //     title:'Wishlist',
  //     icon:'isax isax-heart5',
  //     route: all_routes.studentWishlist
  // },

  // Đây là slidebar của order history
  // Đã xóa vì không cần thiết
  // {
  //     title:'Order History',
  //     icon:'isax isax-shopping-cart5',
  //     route: all_routes.studentOrderHistory
  // },

  // Đây là slidebar của referral
  // Đã xóa vì không cần thiết
  // {
  //     title:'Referrals',
  //     icon:'isax isax-tag-user5',
  //     route: all_routes.studentReferral
  // },
  // {
  //   title: "messages",
  //   icon: "isax isax-messages-35",
  //   route: all_routes.studentMessage,
  // },
  // {
  //   title: "contactSupport",
  //   icon: "isax isax-ticket5",
  //   route: all_routes.studentTickets,
  // },
];
